/**
 * ユーティリティ
 *
 * No.    日付          更新者    更新内容
 *   1    2017/11/07             新規作成
 *
 * @summary データ
 * @copyright 2017, WINGSYSTEMS K.K.
 */

export const Util = {};
export const Device = {};

Device.SP = 'xs';
Device.TB = 'sm';
Device.PC = 'md';
Device.LG = 'lg';

Device.SIZE_SP = 768;
Device.SIZE_TB = 992;
Device.SIZE_PC = 1200;

Util.getDeviceMode = function() {
  var windowWidth = document.documentElement.clientWidth;
  var device = Device.SP;
  if (windowWidth > Device.SIZE_SP) device = Device.TB;
  if (windowWidth > Device.SIZE_TB) device = Device.PC;
  if (windowWidth > Device.SIZE_PC) device = Device.LG;
  return device;
};

Util.isElement = function(obj) {
  try {
    //Using W3 DOM2 (works for FF, Opera and Chrom)
    /* eslint-disable no-undef */
    return obj instanceof HTMLElement;
    /* eslint-enable no-undef */
  }
  catch(e){
    //Browsers not supporting W3 DOM2 don't have HTMLElement and
    //an exception is thrown and we end up here. Testing some
    //properties that all elements have. (works on IE7)
    return (typeof obj==="object") &&
      (obj.nodeType===1) && (typeof obj.style === "object") &&
      (typeof obj.ownerDocument ==="object");
  }
};

Util.isString = function(obj) {
  return (typeof (obj) === "string" || obj instanceof String);
};
